import "./Header.css";
export default function Header() {
	return (
		<div className="header-wrapper">
			<div className="header-container">Code Blog</div>
		</div>
	);
}
